import { render } from "./HazO4List.vue?vue&type=template&id=61c10262"
import script from "./HazO4List.vue?vue&type=script&lang=js"
export * from "./HazO4List.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__